import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { NotificationService } from '@app/core/notifications/notification.service';
import { AppNotification, NotificationStoreService } from '@app/core/notifications/notification-store.service';
import { StylingColoursService } from '@app/modules/site-settings-styling/components/styling-colours/services/styling-colours.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  hub = inject(NotificationService);
  store = inject(NotificationStoreService);
  private router = inject(Router);
  private stylingColoursService = inject(StylingColoursService);

  ngOnInit(): void {
    this.hub.connect();
  }

  get accent(): string {
    return this.stylingColoursService.activeStylingColour?.primaryColour || '#ff9e18';
  }

  get badgeText(): string {
    const count = this.store.unreadCount();
    return count > 9 ? '9+' : `${count}`;
  }

  open(notification: AppNotification) {
    this.store.markRead(notification.id);
    this.router.navigateByUrl(notification.link);
  }

  remove(event: Event, notification: AppNotification) {
    event.stopPropagation();
    this.store.remove(notification.id);
  }

  markAllRead(event: Event) {
    event.stopPropagation();
    this.store.markAllRead();
  }

  clearAll(event: Event) {
    event.stopPropagation();
    this.store.clear();
  }

  retry(event: Event) {
    event.stopPropagation();
    this.hub.retry();
  }

  timeAgo(notification: AppNotification): string {
    return moment(notification.createdAt).fromNow();
  }

  trackById(_: number, notification: AppNotification) {
    return notification.id;
  }
}
